var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "#41BFAC",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.8125C13.866 17.8125 17 14.6785 17 10.8125C17 6.94651 13.866 3.8125 10 3.8125C6.13401 3.8125 3 6.94651 3 10.8125C3 14.6785 6.13401 17.8125 10 17.8125ZM13.6342 8.01249C13.7803 8.01249 13.9203 8.07083 14.0232 8.17455C14.1356 8.27826 14.1996 8.42426 14.1996 8.57722C14.1996 8.73018 14.1356 8.87618 14.0232 8.9799L9.55264 13.4504C9.44977 13.5542 9.30974 13.6125 9.16366 13.6125C9.01758 13.6125 8.87755 13.5542 8.77468 13.4504L6.6709 11.3467C6.52704 11.2077 6.46825 11.0025 6.51666 10.8084C6.56508 10.6144 6.71336 10.4609 6.90564 10.4058C7.09793 10.3507 7.305 10.4023 7.44886 10.5413L9.16366 12.2616L13.2452 8.17455C13.3481 8.07083 13.4881 8.01249 13.6342 8.01249Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckFill);
export default __webpack_public_path__ + "static/media/icon-check-fill.c096a66fa5c87b6dbe6bb399a5fff0d6.svg";
export { ForwardRef as ReactComponent };